import { __t } from '../../i18n/t';
import { AttendantGoalType } from '../../models/attendantGoalType';
import { GoalLevel, InsightKind, OfferErrorCode, OfferStatus, OfferTargetType } from '../../models/attendantGoalOffer';

export const ATTENDANT_GOAL_TRIAL_ROUTE = '/attendant-goal-trial';

export const insightKindFor = (status: OfferStatus): InsightKind => {
  if (status === OfferStatus.active) return InsightKind.trialWeekly;
  if (status === OfferStatus.ended) return InsightKind.trialFinal;
  return InsightKind.offerPitch;
};

/** Manchete de reserva quando a IA não está pronta (unavailable, insufficient_data, erro). Até 20 palavras, sem citar IA nem prêmio. */
export const fixedHeadline = (status: OfferStatus): string => {
  if (status === OfferStatus.active) {
    return __t('Sua degustação está em andamento. Acompanhe o ranking da equipe de pista ao vivo, no monitor.');
  }
  if (status === OfferStatus.ended) {
    return __t('Sua degustação terminou. Veja o antes e o depois da produtividade da equipe.');
  }
  return __t('Saiba quem rende mais e quem precisa de apoio na pista, ao vivo. Já deixamos tudo pronto para testar grátis.');
};

export const goalLevelLabel = (level: GoalLevel): string => {
  if (level === GoalLevel.conservative) return __t('Conservadora');
  if (level === GoalLevel.challenging) return __t('Desafiadora');
  return __t('Equilibrada');
};

/** Quantidade = abastecimentos por dia de cada frentista; fidelização = % dos abastecimentos pelo app; volume = litros por dia. */
export const goalValueText = (type: OfferTargetType, value: number): string => {
  if (type === AttendantGoalType.PERCENTAGE_LOYALTY) return __t('%{n}% de fidelização', { n: value });
  if (type === AttendantGoalType.VOLUME) return __t('%{n} litros por dia', { n: value });
  return __t('%{n} abastecimentos por dia', { n: value });
};

/** Nome do tipo de meta nas listas do convite (a unidade vem em `goalValueShort`). Quadro sem alvo conhecido: "Quadro". */
export const goalTypeLabel = (type: AttendantGoalType | null): string => {
  if (type === AttendantGoalType.QUANTITY) return __t('Quantidade');
  if (type === AttendantGoalType.PERCENTAGE_LOYALTY) return __t('Fidelização');
  if (type === AttendantGoalType.VOLUME) return __t('Volume');
  return type ? AttendantGoalType.translateType(type) : __t('Quadro');
};

/** Valor com a unidade quando o nome do tipo já aparece ao lado; na fidelização basta o percentual. */
export const goalValueShort = (type: OfferTargetType, value: number): string =>
  (type === AttendantGoalType.PERCENTAGE_LOYALTY ? `${value}%` : goalValueText(type, value));

/** Mensagem para o notify de cada erro do convite. `null` (erro de rede ou 5xx) cai no texto genérico. */
export const offerErrorText = (code: OfferErrorCode | null): string => {
  switch (code) {
    case OfferErrorCode.offerNotPending: return __t('Este convite não está mais disponível.');
    case OfferErrorCode.staleSuggestion: return __t('A meta foi atualizada com os dados desta semana');
    case OfferErrorCode.moduleAlreadyActive: return __t('O módulo Meta de Frentista já está ativo na sua rede.');
    case OfferErrorCode.notChainEmployee: return __t('Só o usuário da rede pode fazer isso.');
    case OfferErrorCode.continueNotAvailable: return __t('O pedido para continuar não está disponível agora.');
    case OfferErrorCode.moduleInactive: return __t('O módulo Meta de Frentista está desativado.');
    case OfferErrorCode.noStationAvailable: return __t('Nenhum posto da sugestão está ativo na rede.');
    case OfferErrorCode.insightNotAvailable: return __t('Esta leitura não está disponível para o estado atual do convite.');
    case OfferErrorCode.boardRefused: return __t('Não foi possível criar a meta em um dos postos. Nada foi ativado; tente novamente.');
    case OfferErrorCode.invalidLevels: return __t('Os níveis escolhidos não conferem com os postos da sugestão. Recarregue a página.');
    default: return __t('Não foi possível concluir. Tente novamente.');
  }
};
